import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useInstallPrompt } from "../hooks/useInstallPrompt";

export function InstallPromptBanner() {
  const { t } = useTranslation();
  const { canInstall, isIOS, isFirefoxAndroid, triggerInstall, dismiss } =
    useInstallPrompt();

  const isManual = isIOS || isFirefoxAndroid;

  const description = isIOS
    ? t("pwa.installPrompt.descriptionIos")
    : isFirefoxAndroid
      ? t("pwa.installPrompt.descriptionFirefox")
      : t("pwa.installPrompt.description");

  return (
    <Modal
      opened={canInstall}
      onClose={dismiss}
      title={t("pwa.installPrompt.title")}
      centered
      data-testid="install-prompt-banner"
    >
      <Stack gap="md">
        <Text size="sm">{description}</Text>
        <Group justify="flex-end">
          <Button
            variant="subtle"
            onClick={dismiss}
            data-testid="install-prompt-dismiss"
          >
            {t("pwa.installPrompt.dismiss")}
          </Button>
          {isManual ? (
            <Button onClick={dismiss} data-testid="install-prompt-ok">
              {t("pwa.installPrompt.ok")}
            </Button>
          ) : (
            <Button
              onClick={triggerInstall}
              data-testid="install-prompt-install"
            >
              {t("pwa.installPrompt.install")}
            </Button>
          )}
        </Group>
      </Stack>
    </Modal>
  );
}
